var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blackClock",
    transform: "translate(-2 -2)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Time-Circle",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M7,0A7,7,0,1,1,0,7,7,7,0,0,1,7,0ZM6.755,3.451a.524.524,0,0,0-.525.525h0V7.511a.526.526,0,0,0,.259.448h0L9.233,9.6a.536.536,0,0,0,.273.077.519.519,0,0,0,.448-.259.527.527,0,0,0-.182-.721h0L7.28,7.21V3.976A.524.524,0,0,0,6.755,3.451Z",
    fill: "#101010"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackClock);
export default __webpack_public_path__ + "static/media/blackClock.8582afed8056fad1cd329fef9a1a5308.svg";
export { ForwardRef as ReactComponent };